import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import {
  Layout,
  Menu,
  Button,
  Dropdown,
} from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  AppstoreOutlined,
  UserOutlined,
  CarOutlined,
  SettingOutlined,
  LogoutOutlined,
  ClusterOutlined,
  BellOutlined,
  BarChartOutlined,
  FileTextOutlined,
  ReconciliationOutlined,
  RobotOutlined,
  MessageOutlined,
  CalendarOutlined,
  FileImageOutlined,
} from '@ant-design/icons';
import './MainLayout.css';

const { Sider, Header, Content } = Layout;

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout, isOpcUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toast.info('You have been logged out');
    navigate('/login');
  };

  // Navigation items
  const navigation = isOpcUser
    ? [
        { key: '/daily-runs', label: <Link to="/daily-runs">Daily Runs</Link>, icon: <CalendarOutlined /> },
        { key: '/pods', label: <Link to="/pods">PODs</Link>, icon: <FileImageOutlined /> },
      ]
    : [
        { key: '/jobs', label: <Link to="/jobs">Jobs</Link>, icon: <AppstoreOutlined /> },
        { key: '/drivers', label: <Link to="/drivers">Drivers</Link>, icon: <UserOutlined /> },
        { key: '/vans', label: <Link to="/vans">Vans</Link>, icon: <CarOutlined /> },
        ...(user?.role === 'admin' ? [
          { key: '/payments', label: <Link to="/payments">Payments</Link>, icon: <span style={{ fontSize: '16px' }}>£</span> },
          { key: '/payments/overdue', label: <Link to="/payments/overdue">Overdue Payments</Link>, icon: <BellOutlined style={{ color: 'red' }} /> },
          { key: '/invoices', label: <Link to="/invoices">Invoices</Link>, icon: <FileTextOutlined /> },
          { key: '/reports', label: <Link to="/reports">Reports</Link>, icon: <BarChartOutlined /> },
          { key: '/reconciliation', label: <Link to="/reconciliation">Reconciliation</Link>, icon: <ReconciliationOutlined /> },
        ] : [
          { key: '/invoices', label: <Link to="/invoices">Invoices</Link>, icon: <FileTextOutlined /> },
        ]),
        { key: '/daily-runs', label: <Link to="/daily-runs">Daily Runs</Link>, icon: <CalendarOutlined /> },
        { key: '/pods', label: <Link to="/pods">PODs</Link>, icon: <FileImageOutlined /> },
        { key: '/channels', label: <Link to="/channels">Channels</Link>, icon: <ClusterOutlined /> },
        { key: '/agent-logs', label: <Link to="/agent-logs">Agent Logs</Link>, icon: <RobotOutlined /> },
        { key: '/enquiries', label: <Link to="/enquiries">Enquiries</Link>, icon: <MessageOutlined /> },
        { key: '/settings', label: <Link to="/settings">Settings</Link>, icon: <SettingOutlined /> },
      ];

  // Find the selected key for the current route
  const selectedKey = navigation.find(item => location.pathname === item.key || location.pathname.startsWith(item.key + '/'))?.key || '/dashboard';

  // User dropdown menu
  const userMenu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        breakpoint="lg"
        width={240}
        style={{ background: '#001529' }}
      >
        <div className="logo-container" style={{ display: 'flex', alignItems: 'center', padding: 16 }}>
          <span className="logo-icon" style={{ color: 'white', fontSize: 28, marginRight: 8 }}>🚚</span>
          {!collapsed && (
            <span className="logo-text" style={{ color: 'white', fontWeight: 700, fontSize: 20 }}>
              {isOpcUser ? 'Lite | OPC' : 'Jay & EE'}
            </span>
          )}
        </div>
        <div className="user-info" style={{ color: 'white', padding: collapsed ? '0 8px' : '0 16px', marginBottom: 16 }}>
          {!collapsed && (
            <>
              <div style={{ fontWeight: 500 }}>{user?.firstName} {user?.lastName}</div>
              <div style={{ fontSize: 12, color: '#bfbfbf' }}>{user?.role || 'Administrator'}</div>
            </>
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={navigation}
          style={{ borderRight: 0 }}
        />
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 1px 4px rgba(0,21,41,.08)' }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: 20, marginLeft: 16 }}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginRight: 24 }}>
            <Button type="text" icon={<BellOutlined />} />
            <Dropdown overlay={userMenu} placement="bottomRight">
              <Button type="text" icon={<UserOutlined />}>
                {user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}
              </Button>
            </Dropdown>
          </div>
        </Header>
        <Content style={{ margin: 0, minHeight: 280, background: '#f5f6fa' }}>
          <div style={{ padding: 24 }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;